import React from 'react';
import { useTranslation } from 'react-i18next';
import { LabelInput } from '@/components/ui/inputs/LabelInput';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { IconScout } from '@/components/ui/images/IconScout';
import type { AttendanceDetail } from '@/api/domains/attendance';
import { GoogleStaticMap } from '@/components/ui/maps/GoogleStaticMap';
import { useDetailAttendanceForm } from '@/hooks/attendance';
import { SidePanelFormLayout } from '@/components/layout';
import { hasSafeProtocol } from '@/utils';


export interface DetailsAttendanceFormProps {
  record: AttendanceDetail | null;
  imageUrl?: string;
}

export const DetailsAttendanceForm: React.FC<DetailsAttendanceFormProps> = ({
  record,
  imageUrl: imageUrlProp,
}) => {
  const { t: translate } = useTranslation();
  const {
    fecha,
    hora,
    tipo,
    evento,
    deviceInformation,
    ubicacion,
    mapUrl,
    isUnavailable,
    imageUrl,
  } = useDetailAttendanceForm({ detail: record });
  const effectiveImageUrl = imageUrlProp || imageUrl;
  const canViewPhoto = hasSafeProtocol(effectiveImageUrl);

  return (
    <SidePanelFormLayout data-testid="detalle-asistencia-form">
      {/* Map */}
      <div className="w-full flex justify-center">
        <GoogleStaticMap mapUrl={mapUrl} isUnavailable={isUnavailable} loading={false} />
      </div>

      <SidePanelFormLayout.Fields>
        <LabelInput
          label={translate('attendance:fields.date')}
          value={fecha}
          disabled
          iconRight={<IconScout name="calendarAlt" size="sm" />}
        />
        <LabelInput
          label={translate('attendance:incident.form.time')}
          value={hora}
          disabled
          iconRight={<IconScout name="clockThree" size="sm" />}
        />
        <LabelInput label={translate('attendance:detail.type')} value={tipo} disabled />
        <LabelInput label={translate('attendance:managedAttendance.detail.eventType')} value={evento} disabled />
        <LabelInput label={translate('attendance:detail.device')} value={deviceInformation} disabled />
        <LabelInput label={translate('attendance:managedAttendance.detail.location')} value={ubicacion} disabled />
      </SidePanelFormLayout.Fields>

      {canViewPhoto && (
        <div className="pt-2 flex justify-center">
          <PrimaryButton
            size="sm"
            variant="outline"
            fullWidth
            onClick={() => {
              window.open(
                effectiveImageUrl,
                '_blank',
                'noopener,noreferrer',
              );
            }}
          >
            {translate('attendance:detail.viewPhoto')}
          </PrimaryButton>
        </div>
      )}
    </SidePanelFormLayout>
  );
};

export default DetailsAttendanceForm;
